import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class ContactUSService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allList(): Promise<any> {
        return this.httpmanagerService.HttpGet('contactus', "").then(function (data) {

            return data.data;
        });
    }
    dcontactus(id): Promise<any>{
        return this.httpmanagerService.HttpDelete('contactus',id).then(data =>{
            return data;
        })
    }

}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/contactus/contactus.service.ts